import { render } from "./EmptyRouteComponent.vue?vue&type=template&id=0e2603dc"
import script from "./EmptyRouteComponent.vue?vue&type=script&lang=js"
export * from "./EmptyRouteComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__